export default (location, place) => {
  return new Promise((resolve, reject) => {
    const matrix = new window.google.maps.DistanceMatrixService();
    matrix.getDistanceMatrix(
      {
        origins: [location],
        destinations: [place],
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status !== 'OK') {
          reject(new Error(`DistanceMatrix status ${status}`));
          return;
        }

        const element = response?.rows?.[0]?.elements?.[0];

        // Elemento sem rota (ZERO_RESULTS/NOT_FOUND) não é distância 0:
        // é ausência de medida, e precisa ser tratada como falha.
        if (!element || element.status !== 'OK' || !element.distance) {
          reject(
            new Error(`DistanceMatrix element ${element?.status || 'EMPTY'}`)
          );
          return;
        }

        resolve(element.distance.value / 1000);
      }
    );
  });
};
